import Vue from 'vue'
import VueRouter from 'vue-router'

import routes from './routes'

Vue.use(VueRouter)

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default function (/* { store, ssrContext } */) {
  const Router = new VueRouter({
    scrollBehavior: () => ({ x: 0, y: 0 }),
    routes,

    // Leave these as they are and change in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    mode: process.env.VUE_ROUTER_MODE,
    base: process.env.VUE_ROUTER_BASE
  })

  // ✅ TEMPORARY REDIRECT ONLY FOR ONE TOKEN
  Router.beforeEach((to, from, next) => {
    const TEMP_TOKEN = "c7460be8dbbefd50";
    console.log("Router.beforeEach", to.path);
    // works for:
    // /c7460be8dbbefd50
    // /c7460be8dbbefd50/disconnected
    if (to.path === `/${TEMP_TOKEN}` || to.path.startsWith(`/${TEMP_TOKEN}/`)) {
      window.location.href = `https://onboarding.juste.ai/#/${TEMP_TOKEN}`;
      return;
    }

    next();
  });

  return Router
}
